<div class="hdmui hdmui-container tool-information-dialog" data-testid="tool-information-dialog">
    <header>
        <h2>{{ 'DC.SETTINGS.TOOL_USAGE.DEGREE_OF_WEAR' | translate }}</h2>
    </header>

    <mat-divider></mat-divider>

    <section class="hdmui-content tool-information-dialog__content">
        @for (toolUsage of toolUsages; track toolUsage.id) {
            <mat-card
                appearance="outlined"
                class="tool-information-dialog__card hdmui-background-2"
                [attr.data-testid]="'tool-information-dialog-' + toolUsage.toolPart.toLowerCase()"
            >
                <div class="tool-information-dialog__card-content">
                    <hdmui-key-value-vertical
                        class="tool-information-dialog__tool-part hdmui-m-0"
                        [key]="'DC.SETTINGS.TOOL_USAGE.TOOL_PART' | translate"
                        [wrapText]="true"
                    >
                        {{ 'DC.SETTINGS.TOOL_USAGE.TOOL_PART.' + toolUsage.toolPart | translate }}
                    </hdmui-key-value-vertical>
                    <div class="tool-information-dialog__details">
                        <hdmui-key-value-vertical
                            class="hdmui-m-0"
                            [key]="'DC.SETTINGS.TOOL_USAGE.NUMBER_OF_SETUPS' | translate"
                        >
                            {{ toolUsage.setupCount }}
                        </hdmui-key-value-vertical>
                        <hdmui-key-value-vertical
                            class="hdmui-m-0"
                            [key]="'DC.SETTINGS.TOOL_USAGE.NUMBER_OF_PUNCHES' | translate"
                        >
                            {{ toolUsage.punchCount }}
                        </hdmui-key-value-vertical>
                    </div>
                </div>
            </mat-card>
        }

        <p class="tool-information-dialog__hint hdmui-font-small" data-testid="tool-information-dialog-reset-hint">
            {{ 'DC.SETTINGS.TOOL_USAGE.RESET_HINT' | translate }}
        </p>
    </section>

    <mat-divider></mat-divider>

    <footer>
        <p class="hdmui-font-small hdmui-m-0" data-testid="tool-information-dialog-auto-close-hint">
            {{ 'DC.TRANSITION.WELCOME.COUNTER_TEXT' | translate }} {{ autoCloseSeconds() }}s
        </p>
        <button mat-flat-button type="button" data-testid="tool-information-dialog-continue" (click)="close()">
            {{ 'DC.TRANSITION.WELCOME.BUTTON' | translate }}
        </button>
    </footer>
</div>
